import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDownTrayIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { ui } from '@procuros/datachecks';

import { FileRow } from 'components/Form/FileRow/FileRow';
import { useSchemableFormFileUploadContext } from 'components/SchemableForm/contexts/SchemableFormFileUploadContext/SchemableFormFileUploadContext';

import { FileUploadValue } from '../FileUploadField';

type FileUploadFieldViewProps = {
  field: ui.FileUploadField;
  value: FileUploadValue;
};

export const FileUploadFieldView = ({ field, value }: FileUploadFieldViewProps) => {
  const { t } = useTranslation();
  const fileUploadContextValue = useSchemableFormFileUploadContext();
  const { getFileDownloadUrl } = fileUploadContextValue || {};
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = useCallback(
    async (fileName: string) => {
      if (!getFileDownloadUrl) {
        return;
      }
      setIsDownloading(true);
      try {
        const { url } = await getFileDownloadUrl(fileName);
        window.open(url, '_blank');
      } finally {
        setIsDownloading(false);
      }
    },
    [getFileDownloadUrl],
  );

  return (
    <FileRow
      label={field.label}
      icon={DocumentTextIcon}
      text={value?.original_name ?? ''}
      action={
        value
          ? {
              label: t('common:download'),
              onClick: () => handleDownload(value.file_name),
              loading: isDownloading,
              LeftIcon: ArrowDownTrayIcon,
              analyticsId: 'file_row_download',
            }
          : undefined
      }
    />
  );
};
